// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__KLD2n","row":"header_row__31nZe","title":"header_title__2PDZs","illustration":"header_illustration__2Vc3_","logo":"header_logo__1ut_-"};